id;code;active;mobile;title
1;en;1;0;Developer
2;en_gb;1;1;English
3;da;1;1;Dansk
4;nb;1;1;Norsk
5;sv;1;1;Svenska
6;de;1;1;Deutsch
8;nl;1;1;Nederlands
9;nl_be;1;0;Vlaams Belgium
10;es_es;1;1;Español
11;it;1;1;Italiano
13;lt;1;0;Lietuvių
15;fr;1;1;Français
17;lv;1;0;Latviešu
18;et;1;0;Eesti
19;fi;1;0;Suomi
20;is;1;0;Íslenska
21;pl;1;0;Polskie
22;ro;1;0;Română
23;ca_es;1;0;Català
24;hu;1;0;Magyar
